import React from 'react'
import './TopNav4dept.css'

const TopNav4dept = () => {
  return (
    <nav className='dept-navbar'>
      <div className='dept-header'>
      </div>
    </nav>
  )
}

export default TopNav4dept
